import { PresetColors } from "antd/es/theme/internal";

export const randomColor = () =>
  PresetColors[Math.floor(Math.random() * PresetColors.length + 0.5)];
